<div class="container-fluid">
    <div class="row">
        <div class="col-md-2">
            <select class="form-control input-sm" [(ngModel)]="selectedClient"
                    (ngModelChange)="resetAuditView()"
                    [compareWith]="compareClient">
                @for (client of clients; track $index) {
<option [ngValue]="client">{{ client.client_name }}</option>
}
            </select>
        </div>
        <div class="col-md-3">
            <select style="width:100%" class="form-control input-sm subtableRowHeight"
                    [(ngModel)]="selectedAuditType"
                    (ngModelChange)="getAuditData($event)">
                <option value="" disabled>Select</option>
                @for (option of auditTypes; track $index) {
<option [value]="option | json">{{ option.name }}</option>
}
            </select>
        </div>
    </div>
    <div class="row">
        @if (showDisplayMsg) {
<div class="col-md-12" style="margin: 80px 0;">
            <div class="noSelection">
                Please make a selection for viewing the audit.
            </div>
        </div>
}

        @if (loading) {
<div class="audit-loader">
            <ap-loading [size]="'24px'" [colorName]="'a-primary'"></ap-loading>
        </div>
}

        <!-- UPDATE_USER_DETAILS Section -->
        @if (auditType == 'UPDATE_USER_DETAILS') {
<div class="detailsBlock" style="margin-top: 12px;">
            @if (userAuditMsg) {
<div class="col-md-12" style="margin: 80px 0;">
                <div class="noSelection">
                    No audits to display for the User Details.
                </div>
            </div>
}

            @for (row of userAudit; track $index) {
<div class="col-md-12" style="margin-bottom: 6px;"
                
                 (mouseenter)="row.hover = true" (mouseleave)="row.hover = false">
                <div class="col-md-12 allSettings"
                     [ngClass]="{'selected': row.toggle, 'inactiveTab': !row.toggle && row.hover}">
                    <span class="col-md-11 settingName">Update By : {{ row.updated_by }} ({{ row.updated_on }})</span>
                    <span class="col-md-1 expand_collapse">
                        @if (!row.toggle) {
<i class="fa fa-plus-square-o" style="float: right; cursor: pointer; font-size: 18px;"
                           (click)="row.toggle = !row.toggle"
                           title="Expand"></i>
}
                        @if (row.toggle) {
<i class="fa fa-minus-square-o" style="float: right; cursor: pointer; font-size: 18px;"
                           (click)="row.toggle = !row.toggle"
                           title="Collapse"></i>
}
                    </span>
                </div>
                @if (row.toggle) {
<div>
                    <div class="editBlock">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="user-details">
                                    <div class="user-label">User Type</div>
                                    <div class="user-value">
                                        <select required class="input-sm" name="user_type" disabled
                                                [(ngModel)]="row.user_type"
                                                style="height: 23px; padding: 0px; border: 1px solid #ccc">
                                            @for (type of row.user_types; track $index) {
<option [ngValue]="type.value">{{ type.label }}</option>
}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="user-details">
                                    <div class="user-label">Account Active</div>
                                    <div class="user-value">
                                        <input type="checkbox" autocomplete="off"
                                               [ngModel]="row.active == 1"
                                               (ngModelChange)="row.active = $event ? 1 : 0"
                                               disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (row.clientList?.length > 0) {
<div class="row" style="padding-top: 10px;">
                            <div class="col-md-12">
                                <div class="panel panel-default">
                                    <div class="panel-heading" style="padding-left: 5px; font-weight: 700;">Clients: </div>
                                    <div class="panel-body" style="padding: 2px">
                                        <table class="gt-client table table-bordered table-striped table-condensed" style="margin-bottom: 0px">
                                            <thead>
                                            <tr>
                                                <th style="text-align: center;">Client</th>
                                                <th style="text-align: center;">User Type</th>
                                                <th style="text-align: center;">Active</th>
                                                <th style="text-align: center;">Last Updated By</th>
                                                <th style="text-align: center;">Last Updated On</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            @for (item of row.clientList; track $index) {
<tr
                                                [ngClass]="{'active-client': item.active && item.user_type_key !== null}">
                                                <td>{{ item.client_name }}</td>
                                                <td align="center">
                                                    <select required class="input-sm" name="user_type"
                                                            [(ngModel)]="item.user_type_key" disabled
                                                            style="height: 23px; padding: 0px; border: 1px solid #ccc; color: #333">
                                                        @for (type of row.client_user_types; track $index) {
<option [ngValue]="type.user_type_key">{{ type.label }}</option>
}
                                                    </select>
                                                </td>
                                                <td>
                                                    <div style="text-align: center;">
                                                        <input type="checkbox"
                                                               [ngModel]="item.active == 1"
                                                               (ngModelChange)="item.active = $event ? 1 : 0"
                                                               disabled>
                                                    </div>
                                                </td>
                                                <td align="center">{{ item.updated_by }}</td>
                                                <td align="center">{{ item.updated_on }}</td>
                                            </tr>
}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
}
                    </div>
                </div>
}
            </div>
}
        </div>
}

        <!-- MODULE_ASSIGN Section -->
        @if (auditType == 'MODULE_ASSIGN') {
<div class="modulesBlock" style="margin-top: 12px;">
            @if (moduleAuditMsg) {
<div class="col-md-12" style="margin: 80px 0;">
                <div class="noSelection">
                    No audits to display for the Modules.
                </div>
            </div>
}

            @for (row of moduleAudit; track $index; let idx = $index) {
<div class="col-md-12" style="margin-bottom: 6px;"
                
                 (mouseenter)="row.hover = true" (mouseleave)="row.hover = false">
                <div class="col-md-12 allSettings"
                     [ngClass]="{'selected': row.toggle, 'inactiveTab': !row.toggle && row.hover}">
                    <span class="col-md-11 settingName">Update By : {{ row.updated_by }} ({{ row.updated_on }})</span>
                    <span class="col-md-1 expand_collapse">
                        @if (!row.toggle) {
<i class="fa fa-plus-square-o" style="float: right; cursor: pointer; font-size: 18px;"
                           (click)="row.toggle = !row.toggle"
                           title="Expand"></i>
}
                        @if (row.toggle) {
<i class="fa fa-minus-square-o" style="float: right; cursor: pointer; font-size: 18px;"
                           (click)="row.toggle = !row.toggle"
                           title="Collapse"></i>
}
                    </span>
                </div>
                @if (row.toggle) {
<div>
                    <div class="editBlock">
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                Application Modules:
                                <div style="display: flex; float: right; margin-top: -4px;">
                                    <button class="btn btn-sm button-lable" (click)="toggleAll(row.modulesHierarchyList)">
                                        <span class="fa button-labled"
                                              [ngClass]="{'fa-folder-open': !isAllExpanded(row.modulesHierarchyList), 'fa-folder': isAllExpanded(row.modulesHierarchyList)}"></span>
                                        {{ !isAllExpanded(row.modulesHierarchyList) ? 'Collapse All' : 'Expand All' }}
                                    </button>
                                    <i class="fa fa-search search-icn" aria-hidden="true"></i>
                                    <input type="text" placeholder="Search Item..."
                                           [(ngModel)]="row.searchTerm"
                                           (ngModelChange)="filterMenu(row.modulesHierarchyList, row.searchTerm, 'moduleAudit', idx)"
                                           style="border-radius: 20px; border: 1px solid #ccc; padding-left: 25px;">
                                </div>
                            </div>
                            <div class="panel-body" style="padding: 0 0 10px 0;">
                                @if (loading) {
<div class="audit-loader">
                                    <ap-loading [size]="'24px'" [colorName]="'a-primary'"></ap-loading>
                                </div>
}
                                @if (!loading && row.modulesHierarchyList) {
<div class="nav-panel-admin">
                                    <ng-container *ngTemplateOutlet="moduleTreeLevel; context: { $implicit: row.modulesHierarchyList, depth: 0 }"></ng-container>
                                </div>
}
                            </div>
                        </div>
                    </div>
                </div>
}
            </div>
}
        </div>
}

        <!-- BUSINESS_ASSIGN Section -->
        @if (auditType == 'BUSINESS_ASSIGN') {
<div class="businessBlock" style="margin-top: 12px;">
            @if (businessAuditMsg) {
<div class="col-md-12" style="margin: 80px 0;">
                <div class="noSelection">
                    No audits to display for the Businesses.
                </div>
            </div>
}

            @for (row of businessAudit; track $index) {
<div class="col-md-12" style="margin-bottom: 6px;"
                
                 (mouseenter)="row.hover = true" (mouseleave)="row.hover = false">
                <div class="col-md-12 allSettings"
                     [ngClass]="{'selected': row.toggle, 'inactiveTab': !row.toggle && row.hover}">
                    <span class="col-md-11 settingName">Update By : {{ row.updated_by }} ({{ row.updated_on }})</span>
                    <span class="col-md-1 expand_collapse">
                        @if (!row.toggle) {
<i class="fa fa-plus-square-o" style="float: right; cursor: pointer; font-size: 18px;"
                           (click)="row.toggle = !row.toggle"
                           title="Expand"></i>
}
                        @if (row.toggle) {
<i class="fa fa-minus-square-o" style="float: right; cursor: pointer; font-size: 18px;"
                           (click)="row.toggle = !row.toggle"
                           title="Collapse"></i>
}
                    </span>
                </div>
                @if (row.toggle) {
<div>
                    <div class="col-md-12">
                        <div class="row">
                            @for (item of row.businessHierarchyList; track $index) {
<div style="margin: 10px 5px 0px 5px;">
                                <div class="col-md-12">
                                    <div class="panel panel-default">
                                        <div class="gt-dark-cnt">
                                            <gt-business-assign-menu
                                                [callBackService]="'UserAdminFactory'"
                                                [menuData]="item.value"
                                                [renderingMode]="previewMode"
                                                [userId]="logged_in_user"
                                                [loading]="false"
                                                [taxYear]="taxYear"
                                                [clientKey]="client_key"
                                                [groupObjKey]="0">
                                            </gt-business-assign-menu>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
}
                        </div>
                    </div>
                </div>
}
            </div>
}
        </div>
}
    </div>
</div>

<!-- Recursive module tree template -->
<ng-template #moduleTreeLevel let-nodes let-depth="depth">
    <ul class="module-tree">
        @for (node of nodes; track $index) {
<li [hidden]="node.hidden">
            <div class="module-tree-node" [style.padding-left.px]="depth * 20">
                @if (node.children?.length) {
<span class="node-toggle"
                      (click)="node.collapsed = !node.collapsed">
                    <i class="fa" [ngClass]="node.collapsed ? 'fa-plus-square-o' : 'fa-minus-square-o'"></i>
                </span>
}
                <span class="node-name">{{ node.name }}</span>
                @if (node.roles?.length > 0 && node.role?.label) {
<span class="node-role">
                    <span class="badge badge-role">{{ node.role.label }}</span>
                </span>
}
                @if (node.roles?.length > 0 && !node.role?.label && node.role?.value) {
<span class="node-role">
                    <select class="input-sm role-select" disabled [(ngModel)]="node.role.value">
                        @for (r of node.roles; track $index) {
<option [ngValue]="r.value">{{ r.label || r.name }}</option>
}
                    </select>
                </span>
}
            </div>
            @if (node.children?.length && !node.collapsed) {

                <ng-container *ngTemplateOutlet="moduleTreeLevel; context: { $implicit: node.children, depth: depth + 1 }"></ng-container>
            
}
        </li>
}
    </ul>
</ng-template>
